import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import AlertDialog from 'components/AlertDialog';

import licenses from '../../../../../public/licenses/licenses.generated';

const LicenseDialog = ({ dialogOpen, closeDialog, intl }) => {
  return (
    <AlertDialog
      visible={dialogOpen}
      alertMessage={
        <div>
          <h4 style={{ marginBottom: '2rem' }}><FormattedMessage id="dictionary.licenses" /></h4>
          {licenses.map((lic, i) => (
            <div key={i} style={{ marginBottom: '2rem' }}>
              <p style={{ fontWeight: 600, fontSize: '1.6rem' }}>{lic.dependencies.join(', ')}</p>
              {lic.notices.map((notice, j) => (
                <p key={j} style={{ whiteSpace: 'pre-wrap', fontSize: '1.4rem' }}>
                  {notice}
                </p>
              ))}
              <p style={{ whiteSpace: 'pre-wrap', fontSize: '1.4rem' }}>{lic.content}</p>
            </div>
          ))}
        </div>
      }
      cancelButtonText="dictionary.close"
      onCancel={() => closeDialog()}
      formatMessage={props => <FormattedMessage {...props} />}
      cancelButtonStyle={{ button: 'raised', primary: true }}
      dontFormatMessage
      autoScrollBodyContent
    />
  );
};

LicenseDialog.propTypes = {
  dialogOpen: PropTypes.bool,
  setDialogOpen: PropTypes.func,
  intl: intlShape
};

export default injectIntl(LicenseDialog);
